export const LMS_CERTIFICATES_RESET_STATE = 'LMS_CERTIFICATES_RESET_STATE';
export const LMS_CERTIFICATES_CURRENT_ITEM = 'LMS_CERTIFICATES_CURRENT_ITEM';

export const LMS_CERTIFICATES_REQUEST_LOADING = 'LMS_CERTIFICATES_REQUEST_LOADING';
export const LMS_CERTIFICATES_REQUEST_SUCCESS = 'LMS_CERTIFICATES_REQUEST_SUCCESS';
export const LMS_CERTIFICATES_REQUEST_FAILED = 'LMS_CERTIFICATES_REQUEST_FAILED';

export const LMS_CERTIFICATES_CURRENT_ACTION = 'LMS_CERTIFICATES_CURRENT_ACTION';
export const LMS_CERTIFICATES_RESET_ACTION = 'LMS_CERTIFICATES_RESET_ACTION';
